<template>
  <div>
    <b-card no-body>
      <b-card-header>
          <h3 class="float-left"><i class='fa fa-list'></i> Draw List</h3>
          <!-- <b-button variant="primary" class="float-right" @click="showCreateModal">Create Draw List</b-button> -->
      </b-card-header>
      <b-card-body>
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
          <template v-slot:cell(action)="data">
            <b-button variant="warning" @click="showEditModal(data.item.Id)">Edit</b-button>
          </template>
        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
    </b-card>
    <!-- <b-modal ref="createDrawList" size="lg" header-bg-variant="primary" hide-footer title="Create Draw List">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.cDrawListName.$error)">
                      <label for="cDrawListName">Name</label>
                      <b-form-input type="text" id="cDrawListName" placeholder="Name" v-model="cDrawListName" :state="$v.cDrawListName.$error?false:null" @focus.native="$v.cDrawListName.$touch"></b-form-input>
                      <div v-if="$v.cDrawListName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cDrawListName.required">Name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cDrawListName.minLength">Must have at least {{ $v.cDrawListName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cDrawListName.maxLength">Must not exceed {{ $v.cDrawListName.$params.maxLength.max}} letters</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="createDrawList" :disabled="$v.cDrawListName.$invalid">Create</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="hideCreateModal">Cancel</b-btn>
    </b-modal> -->
    <b-modal ref="editDrawList" size="lg" header-bg-variant="primary" hide-footer title="Edit Draw List">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-form-group :state="!($v.drawId.$error)">
                  <b-row>
                    <b-col sm="8">
                      <label for="drawId">Draw</label>
                      <b-form-select id="drawId" :plain="false" v-model.trim="drawId" :state="$v.drawId.$error?false:null" @blur.native="$v.drawId.$touch">
                        <option :value="null">Please select</option>
                        <option v-for="r in draws" :value="r.Id">{{ r.Name }}</option>
                      </b-form-select>
                      <div v-if="$v.drawId.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.drawId.required">Draw is required</div>
                      </div>
                    </b-col>
                    <b-col sm="4">
                      <label for="addDrawBtn">&nbsp;</label>
                      <div>
                        <b-btn id="addDrawBtn" variant="success" @click="addDraw" :disabled="$v.drawId.$invalid">
                          <i class="fa fa-plus-circle"></i> Add
                        </b-btn>
                      </div>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="listDraws" :fields="listDrawsFields" :current-page="drawsCurrentPage" :per-page="drawsPerPage">
                  <template v-slot:cell(action)="data">
                    <b-button variant="danger" @click="confirmRemoveDraw(data.item.Id)">Remove</b-button>
                  </template>
                </b-table>
                <nav>
                  <b-pagination :total-rows="getRowCount(listDraws)" :per-page="drawsPerPage" v-model="drawsCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="outline-danger" @click="hideEditModal">Cancel</b-btn>
    </b-modal>
    <b-modal ref="confirm" size="sm" centered header-bg-variant="primary" hide-footer title="Remove This Draw">
      <div class="mb-3">
        Are you sure?
      </div>
      <b-button variant="success" @click="removeDraw">Yes</b-button>
      <b-button variant="outline-danger" @click="cancelRemove">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  export default {
    name: 'rule-list-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        listDraws: [],
        draws: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Name', label: 'Name'},
          {key: 'action', label: 'Action'}
        ],
        listDrawsFields: [
          {key: 'Id', label: 'ID'},
          {key: 'DrawId', label: 'Draw ID'},
          {key: 'Code', label: 'Name'},
          {key: 'RuleListName', label: 'Rule List'},
          {key: 'GiftListName', label: 'Gift List'},
          {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        perPage: 10,
        drawsCurrentPage: 1,
        drawsPerPage: 5,
        removeId: '',
        drawId: '',
        cDrawListName: '',
        selectedDrawListId: ''
      }
    },
    validations: {
      drawId: { required },
      cDrawListName: { required, minLength: minLength(2), maxLength: maxLength(50) }
    },
    watch: {
      currentPage: function () {
        this.getDrawLists()
      },
      drawsCurrentPage: function () {
        this.getListDraws()
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      getDrawLists () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/draw/list/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.list
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getListDraws () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/draw/list/draws', {'id': this.selectedDrawListId}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.listDraws = response.data.draws
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getAllDraws () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/draw/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.draws = response.data.draws
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      createDrawList () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/draw/list/create', {'name': this.cDrawListName}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getDrawLists()
            this.hideCreateModal()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Draw List Created')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      addDraw () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/draw/list/add', {'listId': this.selectedDrawListId, 'drawId': this.drawId}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getListDraws()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Draw Added')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      removeDraw () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/draw/list/remove', {'id': this.removeId}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getListDraws()
            this.cancelRemove()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Draw Removed')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      confirmRemoveDraw (id) {
        this.removeId = id
        this.$refs.confirm.show()
      },
      cancelRemove () {
        this.$refs.confirm.hide()
        this.showEditModal(this.selectedDrawListId)
      },
      showCreateModal () {
        this.reset()
        this.$refs.createDrawList.show()
      },
      showEditModal (id) {
        this.selectedDrawListId = id
        this.reset()
        this.getListDraws()
        this.$refs.editDrawList.show()
      },
      hideCreateModal () {
        this.$refs.createDrawList.hide()
      },
      hideEditModal () {
        this.$refs.editDrawList.hide()
      },
      reset () {
        this.ruleId = ''
        this.cDrawListName = ''
      }
    },
    created () {
      this.getAllDraws()
      this.getDrawLists()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/drawlist/DrawListTable.vue